import React, { useState } from 'react';
import { login } from '../services/api';
import AppVersion from '../components/AppVersion';
import RecuperarPassword from '../components/RecuperarPassword';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showRecuperar, setShowRecuperar] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await login(email, password);
      const usuario = response.data.usuario;

      // No necesitamos guardar aquí, lo hace onLogin a través de sessionManager
      onLogin(usuario);
    } catch (error) {
      console.error('Error en login:', error);
      setError(
        error.response?.data?.error || 'Error al iniciar sesión. Verifica tus credenciales.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" style={{
      background: `
        radial-gradient(circle at 20% 30%, rgba(255,255,255,0.35), transparent 50%),
        radial-gradient(circle at 80% 70%, rgba(0,0,0,0.28), transparent 55%),
        linear-gradient(135deg, #1fa55a, #178e4d)
      `
    }}>
      <div className="login-card" style={{
        background: '#FFFFFF',
        backdropFilter: 'blur(6px)',
        boxShadow: '0px 20px 60px rgba(0,0,0,0.25)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <p style={{ 
            marginTop: '16px', 
            color: '#616161', 
            fontSize: '16px',
            fontWeight: 400 
          }}>
            Ingresa tus credenciales para acceder
          </p>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label style={{ fontWeight: 500, color: '#212121', marginBottom: '8px' }}>Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              required
              disabled={loading}
              autoFocus
              style={{ 
                padding: '12px 16px',
                fontSize: '16px',
                borderRadius: '8px',
                borderColor: '#E0E0E0'
              }}
              onFocus={(e) => e.target.style.borderColor = '#FB8C00'}
              onBlur={(e) => e.target.style.borderColor = '#E0E0E0'}
            />
          </div>

          <div className="form-group">
            <label style={{ fontWeight: 500, color: '#212121', marginBottom: '8px' }}>Contraseña</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              disabled={loading}
              style={{ 
                padding: '12px 16px',
                fontSize: '16px',
                borderRadius: '8px',
                borderColor: '#E0E0E0'
              }}
              onFocus={(e) => e.target.style.borderColor = '#FB8C00'}
              onBlur={(e) => e.target.style.borderColor = '#E0E0E0'}
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary" 
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              fontSize: '16px',
              fontWeight: 600,
              borderRadius: '8px',
              marginTop: '24px',
              background: '#27AE60',
              borderColor: '#27AE60'
            }}
            onMouseEnter={(e) => {
              if (!loading) e.target.style.background = '#229954';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#27AE60';
            }}
          >
            {loading ? 'Iniciando sesión...' : 'Ingresar'}
          </button>

          <div style={{ marginTop: '16px', textAlign: 'center' }}>
            <button
              type="button"
              onClick={() => setShowRecuperar(true)}
              style={{
                background: 'none',
                border: 'none',
                color: '#FB8C00',
                textDecoration: 'underline',
                cursor: 'pointer',
                fontSize: '14px',
                padding: '4px 8px'
              }}
            >
              ¿Olvidaste tu contraseña?
            </button>
          </div>
        </form>

        <div style={{ 
          marginTop: '32px', 
          textAlign: 'center', 
          fontSize: '14px', 
          color: '#757575' 
        }}>
          <p>© 2026 Absolute Zero - MealPoint v1.0.0</p>
        </div>
      </div>
      <AppVersion />

      {showRecuperar && (
        <RecuperarPassword
          onClose={() => setShowRecuperar(false)}
        />
      )}
    </div>
  );
}

export default Login;
